"use client";

interface SearchSectionHeaderProps {
  title: string;
  showExpandButton: boolean;
  isExpanded: boolean;
  expandCount: number;
  onToggleExpand: () => void;
  showTopBorder?: boolean;
}

export function SearchSectionHeader({
  title,
  showExpandButton,
  isExpanded,
  expandCount,
  onToggleExpand,
  showTopBorder = false,
}: SearchSectionHeaderProps) {
  return (
    <div
      className={`px-2.5 py-1 sm:px-3 sm:py-1.5 text-[10px] sm:text-[11px] font-semibold text-[#8f98a0] uppercase tracking-wide border-b border-[#2a475e]/50 flex items-center justify-between ${
        showTopBorder ? "border-t border-[#2a475e]/50" : ""
      }`}
    >
      <span>{title}</span>
      {showExpandButton && (
        <button
          onClick={onToggleExpand}
          className="text-[#66c0f4] hover:text-white transition-colors text-xs font-normal normal-case"
        >
          {isExpanded ? "Hide" : `Show ${expandCount} more`}
        </button>
      )}
    </div>
  );
}
